<template>
  <modal title="View Only Modal" anchor="#view-only" id="view-only" :hide-header="true" :hide-footer="true" @hidden="clearRoute">
    <div class="view-only-content justify-content-md-center text-center mt-5">
      <h4 class="title">Read only account</h4>
      <img class="icon" :src="require('images/icons-card-actions-compact-read-only.svg')">
      <div v-if="$root.licenseRequested" class="copy">Your request for an upgraded license has been sent.</div>
      <div v-else class="copy">Upgrade your license now to share content and create collections.</div>
      <div class="p-20-0">
        <a v-if="$root.licenseRequested" class="btn cta-bg btn-disabled" disabled="disabled">
          <span>Awaiting license upgrade</span>
        </a>
        <a v-else class="btn cta-bg" rel="nofollow" data-method="post" :href="requestLicensePath">
          <span>Request license upgrade</span>
        </a>
      </div>
    </div>
  </modal>
</template>

<script>

export default {
  methods: {
    clearRoute: function(){
      this.$router.push({ path: this.$route.path, hash: null });
    },
  },
  computed: {
    requestLicensePath: function() {
      const orgId = !!this.$root.currentOrganization ? this.$root.currentOrganization.id : this.$root.itemOrganization.id;
      return `/license_request?organization_id=${orgId}&redirect_to=back`
    }
  }
}
</script>

<style lang="scss">
  #view-only___BV_modal_outer_ {
    .modal-dialog {
      max-width: 400px;
    }

    #view-only {
      margin-top: 3rem;

      .icon {
        width: 8rem;
        height: 8rem;
        margin: 2.75rem 4.5rem 1.563rem;
        object-fit: contain;
      }

      .copy {
        max-width: 80%;
        margin: auto;
        font-family: SFPro;
        font-size: 1rem;
        line-height: 1.5;
        text-align: center;
        color: #000000;
      }

      .view-only-content {
        .title {
          font-family: SFPro;
          font-size: 1.5rem;
          font-weight: 600;
          text-align: center;
          font-stretch: normal;
          color: #4a4a4a;
        }
      }

      .cta-bg {
        color: white;
      }
    }
  }
</style>
